import React, {useState, useEffect} from "react";
import {connect, useDispatch} from "react-redux";
import {withRouter} from "../../../helpers/withRouter";
import T from "../../../shared/component/t/T";
import snippets from "../../../helpers/snippets";
import {default as _} from '../../../helpers/Translate';
import Storage from "../../../helpers/Storage";
import SearchableInput from "../../../shared/component/SearchableInput/SearchableInput";
import * as roles from "../../../core/constants/Roles";
import {_alert} from "../../../actions/Alert";

function ReportCP_ReportOwners(props) {
    const dispatch = useDispatch()
    const [language] = useState(props.language)
    const [direction] = useState(Storage.directionGet())

    const [NewStudyReport, setNewStudyReport] = useState(props.NewStudyReport)
    const [savedReporters, setSavedReporters] = useState(Storage.getModalReporters())
    const [style, setStyle] = useState("")

    const [users, setUsers] = useState(Storage.getUsers())
    const [reporters, setReporters] = useState([])
    const [assists, setAssists] = useState([])
    const [staffs, setStaffs] = useState([])

    useEffect(() => {
        const getUsers = () =>{
            return new Promise(resolve => {
                setTimeout(() => {
                    resolve(Storage.getUsers())
                }, 500);
              });
        }

        if (snippets.isObjectEmpty(users)) {
            getUsers().then(u => setUsers(u))
        }
    }, []);

    useEffect(()=>{
        let chooseOne = { id: -1, text: "choose_one", value: -1 }
        setReporters([chooseOne, ...reportersMap()])
        setAssists([chooseOne, ...assistantsMap()])
        setStaffs([chooseOne, ...staffsMap()])
    },[users])

    useEffect(()=>{
        setNewStudyReport(props.NewStudyReport)
        if (!snippets.isObjectEmpty(savedReporters) && NewStudyReport?.can_edit){
            setStyle("saved")
        } else{
            setStyle("")
        }
    },[props.NewStudyReport, savedReporters])


    const userList = (roles) => {
        let result = [];
        for (let userId in users) {
            let user = users[userId];
            if (user.active && (user.roles & roles) > 0) {
                result = [...result, user];
            }
        }
        return result;
    }

    const reporter = () => {
        let reportersCode = (roles.ROLE_TYPIST | roles.ROLE_ASSISTANT | roles.ROLE_STAFF)
        return userList(reportersCode)
    }
    const reportersMap = () => {
        return reporter().map((element) => ({
            id: element.id,
            text: element.display_name,
            value: element.id,
        }));
    }

    const assistants = () => {
        return userList(roles.ROLE_ASSISTANT)
    }
    const assistantsMap = () => {
        return assistants().map((element) => ({
            id: element.id,
            text: element.display_name,
            value: element.id,
        }));
    }

    const staff = () => {
        return userList(roles.ROLE_STAFF)
    }
    const staffsMap = () => {
        return staff().map((element) => ({
            id: element.id,
            text: element.display_name,
            value: element.id,
        }));
    }

    const handleSaveOwners = () => {
        let modalReporters ={
            "typist_id": NewStudyReport.typist_id,
            "reporter_id": NewStudyReport.reporter_id,
            "resident2_id": NewStudyReport.resident2_id,
            "verifier_id": NewStudyReport.verifier_id,
        }
        Storage.setModalReporters(modalReporters)
        setSavedReporters(modalReporters)
        dispatch(_alert(true, 'success', <T token={"save_reporters_for_another_report_notification"} />))
    }

    const handleRecoverOwners = () => {
        if (!snippets.isObjectEmpty(savedReporters)){
            let someProperty = NewStudyReport
            someProperty["typist_id"] = savedReporters["typist_id"]
            someProperty["reporter_id"] = savedReporters["reporter_id"]
            someProperty["resident2_id"] = savedReporters["resident2_id"]
            someProperty["verifier_id"] = savedReporters["verifier_id"]
            batchChanges(someProperty)
        } else{
            console.log("there is no saved reporters", savedReporters)
        }
    }

    const dropdownChanges = (value, target) => {
        value === -1 ? props.onChange(target, null) : props.onChange(target, parseInt(value))
    }

    const batchChanges = (list) => {
        props.changeValuesArray(list)
    }


    return (
        <>
            <div className="reportOwnersDiv">
                <div className={`save_myChoices ${direction}`}>
                    <i className={`fal fa-save ${style}`}
                       onClick={handleSaveOwners}
                       title={_.init("save_reporters_for_another_report", language)}
                    />
                    <i className={'fal fa-thumb-tack'}
                       style={{"visibility":style==="saved"?"visible":"hidden"}}
                       onClick={handleRecoverOwners}
                       title={_.init("load_saved_reporters", language)}
                    />
                </div>

                <div className={"owner"}>
                    <div className='__title'>
                        <T token={'typist'} />:
                    </div>
                    <SearchableInput options={reporters}
                                     name={"typist_id"}
                                     onChange={dropdownChanges}
                                     defaultValue={NewStudyReport?.typist_id}
                                     disable={!NewStudyReport?.can_edit}
                                     direction={direction}
                    />
                </div>

                <div className={"owner"}>
                    <div className='__title'>
                        <T token={'assistant_1'} />:
                    </div>
                    <SearchableInput options={reporters}
                                     name={"reporter_id"}
                                     onChange={dropdownChanges}
                                     defaultValue={NewStudyReport?.reporter_id}
                                     disable={!NewStudyReport?.can_edit}
                                     direction={direction}
                    />
                </div>

                <div className={"owner"}>
                    <div className='__title'>
                        <T token={'assistant_2'} />:
                    </div>
                    <SearchableInput options={assists}
                                     name={"resident2_id"}
                                     onChange={dropdownChanges}
                                     defaultValue={NewStudyReport?.resident2_id}
                                     disable={!NewStudyReport?.can_edit}
                                     direction={direction}
                    />
                </div>

                <div className={"owner"}>
                    <div className='__title'>
                        {NewStudyReport?.with_staff === false ? <T token={'Verify_without_staff'} /> :
                            NewStudyReport?.with_staff === true ? <T token={'Verify_with_staff'} /> : <T token={'staff'} />}:
                    </div>
                    <SearchableInput options={staffs}
                                     name={"verifier_id"}
                                     onChange={dropdownChanges}
                                     defaultValue={NewStudyReport?.verifier_id}
                                     disable={!NewStudyReport?.can_edit}
                                     direction={direction}
                    />
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(withRouter(ReportCP_ReportOwners));